const CACHE_KEY = "breadcrumb_name_cache_v1";
const CACHE_UPDATED_EVENT = "breadcrumb-cache-updated";

const readCache = () => {
  try {
    const raw = localStorage.getItem(CACHE_KEY);
    if (!raw) return {};
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== "object") return {};
    return parsed;
  } catch (error) {
    console.warn("Failed to read breadcrumb cache:", error);
    return {};
  }
};

const writeCache = (cache) => {
  try {
    localStorage.setItem(CACHE_KEY, JSON.stringify(cache));
    window.dispatchEvent(new CustomEvent(CACHE_UPDATED_EVENT));
  } catch (error) {
    console.warn("Failed to write breadcrumb cache:", error);
  }
};

export const breadcrumbCacheUpdatedEvent = CACHE_UPDATED_EVENT;

export const getCachedBreadcrumbLabel = (type, id) => {
  if (!type || !id) return null;
  const cache = readCache();
  const typeBucket = cache[type];
  if (!typeBucket || typeof typeBucket !== "object") return null;
  const entry = typeBucket[id];
  return entry?.label || null;
};

export const setCachedBreadcrumbLabel = (type, id, label) => {
  const trimmed = typeof label === "string" ? label.trim() : "";
  if (!type || !id || !trimmed) return;
  const cache = readCache();
  if (!cache[type]) {
    cache[type] = {};
  }
  cache[type][id] = {
    label: trimmed,
    updatedAt: Date.now(),
  };
  writeCache(cache);
};
